import React from "react";
import * as stylex from "@stylexjs/stylex";
import { Button } from "@zendeskgarden/react-buttons";
import "../styles/variables.stylex";
import { ZendeskThemeVariables } from "../styles/variables.stylex";
type Props = {
  title: string | React.ReactNode;
  description: string | React.ReactNode;
  confirmLabel?: string;
  cancelLabel?: string;
  onConfirm(): void;
  onCancel(): void;
};

/** Presents a full-screen confirmation prompt when the embedded app needs an explicit yes-or-no decision. */
export const FullViewPrompt = (props: Props) => {
  const {
    title,
    description,
    onCancel,
    onConfirm,
    confirmLabel,
    cancelLabel
  } = props;
  return <div className="sx-ixxii4 sx-13vifvy sx-3m8u43 sx-1ey2m1c sx-u96u03 sx-1vjfegm sx-78zum5 sx-98rzlu sx-6s0dn4 sx-l56j7k sx-dt5ytf sx-w09woa sx-n9heto sx-17e5z5g">
      <div className="sx-1s688f">{title}</div>
      <div>{description}</div>

      <div className="sx-78zum5 sx-tqikln sx-qui205">
        <Button isPrimary type="submit" onClick={onConfirm}>
          {confirmLabel || "Confirm"}
        </Button>
        <Button isBasic onClick={onCancel}>
          {cancelLabel || "Cancel"}
        </Button>
      </div>
    </div>;
};